import { useState } from "react";
import { toast } from "sonner";
import { Send, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/whatsapp";
import { SERVICES } from "@/data/services";

const inputClass =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20";

const QuoteForm = ({ defaultService = "", compact = false }) => {
  const [form, setForm] = useState({
    name: "",
    service: defaultService,
    area: "",
    details: "",
  });

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.service || !form.area.trim()) {
      toast.error("Completa tu nombre, el servicio y tu barrio para cotizar.");
      return;
    }
    const service = SERVICES.find((s) => s.slug === form.service);
    const message = [
      `¡Hola Colors Limpieza! Soy ${form.name.trim()}.`,
      `Quiero cotizar: ${service ? service.name : form.service}.`,
      `Ubicación: ${form.area.trim()}, Medellín.`,
      form.details.trim() ? `Detalles: ${form.details.trim()}.` : "",
    ]
      .filter(Boolean)
      .join("\n");
    window.open(waLink(message), "_blank", "noopener,noreferrer");
    toast.success("¡Listo! Abrimos WhatsApp con tu cotización.");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={compact ? "space-y-4" : "grid gap-4 sm:grid-cols-2"}
      data-testid="quote-form"
    >
      <div>
        <label htmlFor="quote-name" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">
          Tu nombre
        </label>
        <input
          id="quote-name"
          type="text"
          placeholder="Ej: Carolina Gómez"
          className={inputClass}
          value={form.name}
          onChange={set("name")}
          data-testid="quote-form-name-input"
        />
      </div>
      <div>
        <label htmlFor="quote-service" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">
          Servicio
        </label>
        <select
          id="quote-service"
          className={inputClass}
          value={form.service}
          onChange={set("service")}
          data-testid="quote-form-service-select"
        >
          <option value="">Selecciona un servicio</option>
          {SERVICES.map((s) => (
            <option key={s.slug} value={s.slug}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="quote-area" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">
          Barrio o sector
        </label>
        <input
          id="quote-area"
          type="text"
          placeholder="Ej: El Poblado, Laureles, Envigado"
          className={inputClass}
          value={form.area}
          onChange={set("area")}
          data-testid="quote-form-area-input"
        />
      </div>
      <div>
        <label htmlFor="quote-details" className="mb-1.5 block text-xs font-semibold uppercase tracking-widest text-slate-500">
          Detalles (opcional)
        </label>
        <input
          id="quote-details"
          type="text"
          placeholder="Ej: Sofá en L de 5 puestos, colchón king"
          className={inputClass}
          value={form.details}
          onChange={set("details")}
          data-testid="quote-form-details-input"
        />
      </div>
      <div className={compact ? "" : "sm:col-span-2"}>
        <button
          type="submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-4 text-sm font-bold text-white shadow-lg transition-all hover:bg-[#1EBE5A] hover:shadow-xl"
          data-testid="quote-form-submit-whatsapp"
        >
          <MessageCircle size={18} />
          Recibir cotización por WhatsApp
          <Send size={16} />
        </button>
        <p className="mt-3 text-center text-xs text-slate-400">
          Respuesta en menos de 15 minutos en horario de atención. Sin compromiso.
        </p>
      </div>
    </form>
  );
};

export default QuoteForm;
